// noinspection AllyPlainJsInspection

import i18n from "@/locales/index"

export default [
  [
    {
      name: "shipmentCompanyName",
      label: i18n.tc("companyName"),
      type: "text",
      placeholder: i18n.tc("companyName2"),
      required: false,
      size: {
        md: 6,
        lg: 4,
      },
    },
  ],
  [
    {
      name: "shipmentSalutation",
      label: i18n.tc("salutation"),
      type: "text",
      placeholder: i18n.tc("salutation2"),
      required: false,
      size: {
        md: 6,
        lg: 6,
      },
    },
    {
      name: "shipmentFirstName",
      label: i18n.tc("firstName"),
      type: "text",
      placeholder: i18n.tc("firstName2"),
      required: false,
      size: {
        md: 6,
        lg: 6,
      },
    },
    {
      name: "shipmentLastName",
      label: i18n.tc("lastName"),
      type: "text",
      placeholder: i18n.tc("lastName2"),
      required: false,
      size: {
        md: 6,
        lg: 6,
      },
    },
    {
      name: "shipmentStreet",
      label: i18n.tc("street"),
      type: "text",
      placeholder: i18n.tc("street2"),
      required: true,
      size: {
        md: 6,
        lg: 6,
      },
    },
    {
      name: "shipmentHouseNumber",
      label: i18n.tc("houseNumber"),
      type: "text",
      placeholder: i18n.tc("houseNumber2"),
      required: true,
      size: {
        md: 6,
        lg: 6,
      },
    },
    {
      name: "shipmentHouseNumberAddition",
      label: i18n.tc("houseNumberAddition"),
      type: "text",
      placeholder: i18n.tc("houseNumberAddition2"),
      required: false,
      size: {
        md: 6,
        lg: 6,
      },
    },
    {
      name: "shipmentZipCode",
      label: i18n.tc("zipcode"),
      type: "text",
      placeholder: i18n.tc("zipcode2"),
      required: true,
      size: {
        md: 6,
        lg: 6,
      },
    },
    {
      name: "shipmentCity",
      label: i18n.tc("city"),
      type: "text",
      placeholder: i18n.tc("city2"),
      required: true,
      size: {
        md: 6,
        lg: 6,
      },
    },
    {
      name: "shipmentCountryID",
      label: i18n.tc("country"),
      type: "select",
      options: [
        { text: "Albania", value: "AL" },
        { text: "Andorra", value: "AD" },
        { text: "Armenia", value: "AM" },
        { text: "Austalia", value: "AU" },
        { text: "Austria", value: "AT" },
        { text: "Azerbaidjan", value: "AZ" },
        { text: "Belgium", value: "BE" },
        { text: "Bosnia-Herzegovina", value: "BA" },
        { text: "Bulgaria", value: "BG" },
        { text: "Croatia", value: "HR" },
        { text: "Cyprus", value: "CY" },
        { text: "Czech Republic", value: "CZ" },
        { text: "Denmark", value: "DK" },
        { text: "Estonia", value: "EE" },
        { text: "Finland", value: "FI" },
        { text: "France", value: "FR" },
        { text: "Georgia", value: "GE" },
        { text: "Germany", value: "DE" },
        { text: "Great Britain", value: "GB" },
        { text: "Greece", value: "GR" },
        { text: "Hungary", value: "HU" },
        { text: "Iceland", value: "IS" },
        { text: "Ireland", value: "IE" },
        { text: "Italy", value: "IT" },
        { text: "Latvia", value: "LV" },
        { text: "Liechtenstein", value: "LI" },
        { text: "Lithuania", value: "LT" },
        { text: "Luxembourg", value: "LU" },
        { text: "Macedonia", value: "MK" },
        { text: "Malta", value: "MT" },
        { text: "Moldavia", value: "MD" },
        { text: "Monaco", value: "MC" },
        { text: "Montenegro", value: "ME" },
        { value: "NL", text: i18n.tc("theNetherlands") },
        { text: "Norway", value: "NO" },
        { text: "Poland", value: "PL" },
        { text: "Portugal", value: "PT" },
        { text: "Romania", value: "RO" },
        { text: "Russia", value: "RU" },
        { text: "San Marino", value: "SM" },
        { text: "Serbia", value: "RS" },
        { text: "Serbia", value: "RS" },
        { text: "Slovak Republic", value: "SK" },
        { text: "Slovenia", value: "SI" },
        { value: "ZA", text: "South Africa" },
        { text: "South Korea", value: "KR" },
        { text: "Spain", value: "ES" },
        { text: "Sweden", value: "SE" },
        { text: "Switzerland", value: "CH" },
        { text: "Turkey", value: "TR" },
        { text: "Ukraine", value: "UA" },
        { text: "USA", value: "US" },
        { text: "Vatican City", value: "VA" },
      ],
      value: "",
      placeholder: i18n.tc("country"),
      required: true,
      size: {
        md: 6,
        lg: 6,
      },
    },
    {
      name: "shipmentTel",
      label: i18n.tc("telephoneNumber"),
      type: "text",
      placeholder: i18n.tc("telephoneNumber"),
      required: false,
      size: {
        md: 6,
        lg: 6,
      },
    },
  ],
]
